import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { getMsalInstance } from 'services/msalConfig';
import * as authService from 'services/authService';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Login con Microsoft (Entra ID) por REDIRECT: al volver de Microsoft, MSAL procesa la
// respuesta acá (antes de montar la app) y canjea el ID token por el JWT de Legal365.
// En una carga normal, handleRedirectPromise() devuelve null y no hace nada.
async function bootstrap() {
  try {
    const msal = await getMsalInstance();
    const result = await msal.handleRedirectPromise();
    if (result && result.idToken) {
      try {
        await authService.loginWithEntra(result.idToken);
        // Limpia el hash del redirect de la URL.
        window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
      } catch (exchangeErr) {
        // Falló el canje del ID token por el JWT de Legal (usuario no habilitado, backend caído, etc.).
        // Mensaje GENÉRICO al usuario vía ?reason (no se revela el motivo, para evitar enumeración).
        console.error('Login con Microsoft: no se pudo completar el inicio de sesión.', exchangeErr);
        window.history.replaceState({}, document.title, '/login?reason=entra_failed');
      }
    }
  } catch (err) {
    // Error en el propio retorno de MSAL (respuesta de redirect inválida, etc.).
    console.error('Error procesando el retorno de Microsoft (MSAL):', err);
    window.history.replaceState({}, document.title, '/login?reason=entra_failed');
  }

  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

bootstrap();
